
export function validateToken(){
  return new Promise((resolve,reject)=>{
    
    const userInfo = JSON.parse(localStorage.getItem("USER"));
    const tokenInfo = JSON.parse(localStorage.getItem("TOKENINFO"));
    const currentTime = Date.parse(new Date());
    if (!(tokenInfo && tokenInfo.expire)){
      reject(new Error('Token Not found'));
    } else if(currentTime > tokenInfo.expire){
      renewToken(userInfo.userId,tokenInfo,resolve,reject);
    } else{
      //console.log('Token not expired');
      resolve();//no need to renew token
    }

  });
}

function renewToken(userId,tokenInfo,resolve,reject){
  //console.log('Renewing token');
  //console.log(tokenInfo);
  fetch('/auth/RenewAccessToken', {
    method: "POST",
      cache: "no-cache",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: userId,token:tokenInfo.token, refreshToken:tokenInfo.refreshToken, expiry:tokenInfo.expire}),
    })
    .then(response => response.json())
    .then(result => { 
      if(result.success){
        
        const nowTokenInfo = {
          token:result.token,
          expire:Date.parse(result.tokenExpire),
          refreshToken:result.refreshToken
        }
        
        localStorage.setItem("TOKEN", result.token);
        localStorage.setItem("TOKENINFO", JSON.stringify(nowTokenInfo));
        resolve();
      }
      else{
        reject(new Error(result.message));
      }
      
    })
    .catch(err => {
      reject(err);
    });
}
  
  export function clearTokens() {
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("TOKENINFO");
  }
